import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils"

import { useStockChangesPriceEvolutionData } from "./@hooks"
import StockChangesPriceEvolutionChartToolbar from "./Toolbar"


export default function StockChangesPriceStockEvolutionChart() {
    const { 
        dataEvolution, dataEvolutionKeys, skuName, isLoadingDataEvolution, currency, resetEvolutionData, 
        handleChangeEvolutionPeriod, retailer, chartColors, dateRange
    } = useStockChangesPriceEvolutionData()
    
	if (isEmpty(dataEvolution) || isLoadingDataEvolution) return <></>

    const statusLabels = {
		'stock': 'Stock',
		'out-of-stock': 'Out Of Stock',
		'deslisted': 'Delisted',
		'not-listed': 'Not Listed',
		'not-launched': 'Not Launched',
	}
    
    return <ModalSeeker 
        hideActions 
        id="price-stock-evolution"
        isOpen={!isEmpty(dataEvolution)} 
        title={`Price & Stock Evolution - ${skuName} - ${retailer}`}
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            rootID='price-stock-evolution'
            data={dataEvolution}
            title={<Box id="evolution-price-chart"></Box>}
            pdfProps={{
                titlePDF:`Price & Stock Evolution - ${skuName} - ${retailer}`
            }}
            series={[
                {
                    name: "Price",
                    yField: "price",
                    xField: "date",
                    type: "line",
                    connect: true,
                    tooltip: {
                        labelText: "[bold]Price: {valueY}[/]",
                    },
                },
                ...(dataEvolutionKeys.map(key => ({
                    name: statusLabels[key], 
                    yField: key,
                    xField: "date",
                    color: chartColors[key],
                    strokes: {
                        strokeDasharray: [0, 100000]
                    },
                    bullets: { 
                        hidden: false, 
                        radius: 10,
                        fill: chartColors[key]
                    },
                    tooltip: {
                        labelText: "[bold]{statusLabel}[/]"
                    },
                }))),	
            ]}
            chartProps={{
                numberFormat: `#,###.00 ' ${currency}'`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                }
            }}
            cardProps={{ 
                actions: 
                <StockChangesPriceEvolutionChartToolbar 
                    dateRange={dateRange}
                    onChange={handleChangeEvolutionPeriod}
                /> 
            }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}